import { render, staticRenderFns } from "./SelectDaysComponent.vue?vue&type=template&id=bdf005ca&scoped=true&"
import script from "./SelectDaysComponent.vue?vue&type=script&lang=ts&"
export * from "./SelectDaysComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SelectDaysComponent.vue?vue&type=style&index=0&id=bdf005ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf005ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VCol,VRow})
